goog.provide("shadow.js.shim.module$date_fns$setDefaultOptions$default");
shadow.js.shim.module$date_fns$setDefaultOptions$default = esm_import$date_fns$setDefaultOptions.default;
